
import { Component, Vue } from "vue-property-decorator";
import {
  IDeliveryNoteModel,
  IDeliveryNoteStorageLayerModel,
  IStorageModel,
} from "@/api/types";
import { editInformation, getDeliveryNote } from "@/api/overivew-diagram";
import Pagination from "@/components/Pagination/index.vue";
import { Form, Message } from "element-ui";
import {
  getAllMultipleStorageRows,
  getAvailableStorageLayers,
  getStorages,
  updateUpload,
} from "@/api/storages";
import {
  defaultDeliveryNoteData,
  getDeliveryNotePackages,
  getDeliveryNoteStateList,
  getStorageLayers,
  updateStorageLayers,
} from "@/api/delivery-note";
import { createInventoryPlans } from "@/api/inventory-plan";
import HqPackingListProductList from "@/views/components/HqPackingListProductList.vue";
import HqPackingListProductListCopy from "@/views/components/HqPackingListProductListCopy.vue";
import {
  CustomsPacking,
  HqPackingListDetail,
} from "@/model/HqPackingListModels";
import {
  moveCustomsPackingStorageLayers,
  statisticsCustomsPackingData,
  updateProductQuantity,
} from "@/api/customs-packing";

@Component({
  name: "DeliveryNoteStorageManagement",
  components: {
    HqPackingListProductList,
    HqPackingListProductListCopy,
    Pagination,
  },
})
export default class extends Vue {
  private informationVisible = false;
  private toSingleRowVisible = false;
  private tableKey = 0;
  private allStorageLayerList: IStorageModel[] = [];
  private iDeliveryNoteModels: IDeliveryNoteModel[] = [];
  private cascadeProps = {
    multiple: true,
    emitPath: false,
    value: "id",
    label: "name",
  };
  private total = 0;
  private listLoading = true;
  private deliveryNoteInStateList: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];
  private deliveryNoteOutStateList: [{ name: string; desc: string }] = [
    { name: null, desc: null },
  ];
  private dialogStatus = "";
  private moveInventoryDialogStatus = "";
  private moveInventoryDialogVisible = false;
  private actionName = {
    writeInformation: "填写信息",
    updateStorageLayers: "移动库区",
    moveInventory: "移动库存",
    updateQuantity: "修改数量",
  };

  private payload = new DeliveryNoteStorageLayerInput();
  private rules = {
    estimatedNextDeliveryDate: [
      { required: true, message: "请选择预计下次发货时间", trigger: "blur" },
    ],
    estimatedInStorageDateStart: [
      { required: true, message: "请选择预计在库时间", trigger: "blur" },
    ],
    remark: [{ required: true, message: "请填写备注", trigger: "blur" }],
  };
  private listParam = {
    selectedStorageLayer: [],
    code: null,
    storageLayerIds: null,
    storageLayerNames: null,
    inStates: null,
    outStates: null,
    logisticsClerkName: null,
    sellerName: null,
    pageNumber: 1,
    pageSize: 20,
  };
  storageLayerNames: string;
  private selectedDeliveryNoteIds: string[] = [];
  private selectedRow: IDeliveryNoteModel = defaultDeliveryNoteData;
  // private hqPackingListDetails: HqPackingListDetail[] = [];
  private hqPackingListDetails = [] as any;
  cascaderProps = { emitPath: false, value: "id", label: "name" };
  private statistics = new Statistics();

  created() {
    this.getList();
    this.initAllStorageLayerList();
    this.initDeliveryNoteStateList();
  }

  private async initDeliveryNoteStateList() {
    const { out, inStates }: any = await getDeliveryNoteStateList();
    this.deliveryNoteInStateList = inStates;
    this.deliveryNoteOutStateList = out;
  }

  private getHiddenColumnsAsValue(value: string) {
    if (
      this.$route.meta.buttonCodes &&
      Array.isArray(this.$route.meta.buttonCodes)
    ) {
      return this.$route.meta.buttonCodes.includes(value);
    }
  }

  private async initAllStorageLayerList() {
    const data: any = await getStorages();
    this.allStorageLayerList = data;
  }

  private onDialogConfirmed() {
    if (this.dialogStatus === "updateStorageLayers") {
      this.doUpdateStorageLayers();
    }
  }

  private async doUpdateStorageLayers() {
    if (this.payload.storageLayerIds) {
      await updateStorageLayers(this.payload.id, {
        storageLayerIds: this.payload.storageLayerIds,
      });
      this.toSingleRowVisible = false;
      this.$notify({
        title: "Success",
        message: "操作成功",
        type: "success",
        duration: 2000,
      });
      await this.getList();
    }
  }

  private handleSelectionChange(rows) {
    this.selectedDeliveryNoteIds = rows.map((row) => row.id);
  }

  private isSelectable(row: IDeliveryNoteModel) {
    return !row.reserved;
  }

  private showMoveInventoryDialog(status: string, row: IDeliveryNoteModel) {
    this.moveInventoryDialogStatus = status;
    this.selectedRow = row;
    this.queryHqPackingListParams.hqPackingListCode = "";
    this.queryHqPackingListParams.customsPackingCode = "";
    this.moveInventoryDialogVisible = true;
    this.queryHqPackingList();
  }

  private showDiaLog(action: string, row: IDeliveryNoteModel) {
    this.getDeliveryNoteStorageLayers(row.id);
    this.getAvailableStorageLayers(row.reserved, row.id);
    this.toSingleRowVisible = true;
    this.dialogStatus = action;
    this.payload.storageLayerNames = row.storageLayerNames;
    this.payload = new DeliveryNoteStorageLayerInput(row?.id);
    this.$nextTick(() => {
      (this.$refs.dataForm as Form).clearValidate();
    });
  }

  private async getDeliveryNoteStorageLayers(deliveryNoteId: string) {
    const data: any = await getStorageLayers(deliveryNoteId);
    this.payload.storageLayerIds = data.map((value) => value.id);
  }

  private async getAvailableStorageLayers(
    reserved: boolean,
    deliveryNoteId: string
  ) {
    const data: any = await getAvailableStorageLayers({
      isReserved: reserved,
      deliveryNoteId: deliveryNoteId,
    });
    this.allStorageLayerList = data;
  }

  private writeInformation(
    action: string,
    row: IDeliveryNoteStorageLayerModel
  ) {
    this.payload = new DeliveryNoteStorageLayerInput(
      row?.id,
      row.estimatedInStorageDateStart,
      row.estimatedInStorageDateEnd,
      row.estimatedNextDeliveryDate,
      row.remark
    );
    this.informationVisible = true;
    this.dialogStatus = action;
  }

  private async changeCanUpload(row) {
    const canUpload = row.canUpload !== null && !row.canUpload === true;
    await updateUpload(row.id, { canUpload: canUpload });
    await this.getList();
  }
  private closeDialog() {
    this.moveInventoryDialogVisible = false;
    let HqPackingListProductListCopyList = this.$refs.HqPackingListProductListCopy as any
    if(HqPackingListProductListCopyList.length > 0) {
      HqPackingListProductListCopyList.forEach((item) => {
        item.$refs.customsPackingTable.clearSelection();
      })
    }
  }
  private clearSelect() {
    let HqPackingListProductListCopyList = this.$refs.HqPackingListProductListCopy as any
    if(HqPackingListProductListCopyList.length > 0) {
      HqPackingListProductListCopyList.forEach((item) => {
        item.$refs.customsPackingTable.clearSelection();
      })
    }
  }

  private getCanUploadText(row) {
    if (row.canUpload !== null && !row.canUpload === true) {
      return "禁止上传";
    } else {
      return "可上传";
    }
  }

  private handleClose() {
    this.informationVisible = false;
    this.toSingleRowVisible = false;
  }

  private onInformationConfirmed() {
    // if (this.payload.estimatedInStorageDateEnd < this.payload.estimatedInStorageDateStart) {
    //   Message({
    //     message: "结束日期必须大于起始日期",
    //     type: "error",
    //     duration: 2 * 1000
    //   });
    //   return;
    // }

    (this.$refs.dataForm as Form).validate(async (valid) => {
      if (valid) {
        await editInformation(this.payload.id, this.payload);
        this.informationVisible = false;
        this.$notify({
          title: "成功",
          message: "更新成功",
          type: "success",
          duration: 2000,
        });
        this.informationVisible = false;
        await this.getList();
      }
    });
  }

  private handleFilter() {
    this.listParam.pageNumber = 1;
    this.getList();
  }

  private async getList() {
    this.listLoading = true;
    const params = {
      pageNumber: this.listParam.pageNumber,
      pageSize: this.listParam.pageSize
    }
    const data = Object.assign({}, this.listParam);
    if (data.selectedStorageLayer) {
      data.storageLayerIds = data.selectedStorageLayer.join(",");
      data.selectedStorageLayer = null;
    }
    const { total, content }: any = await getDeliveryNote(params,data);
    this.total = total;
    this.iDeliveryNoteModels = content;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.1 * 1000);
  }

  private handleCreateInventoryPlan() {
    if(this.selectedDeliveryNoteIds.length === 0) {
      this.$notify({
        title: "提示",
        message: "请选择数据！",
        type: "warning",
        duration: 2000,
      });
      return
    }
    createInventoryPlans({ deliveryNoteIds: this.selectedDeliveryNoteIds })
      .then(() => {
        this.$router.push({
          name: "InventoryPlanManagement",
        });
      })
      .catch();
  }

  private queryHqPackingListParams = {
    hqPackingListCode: "",
    customsPackingCode: "",
  };

  private queryHqPackingList() {
    getDeliveryNotePackages(
      this.selectedRow.id,
      this.queryHqPackingListParams
    ).then((res: any) => {
      this.hqPackingListDetails = res.map((value) => value.hqPackingList);
      if(this.moveInventoryDialogStatus === 'moveInventory') {
        this.$nextTick(() => {
          let comList = this.$refs.HqPackingListProductListCopy as any;
          if(comList && comList.length > 0){
            comList.forEach((item) => {
              item.carryOut();
            })
          }
        })
      }
    });
  }

  private showPackingList(row: IDeliveryNoteModel) {
    this.$router.push({
      name: "PackingList",
      params: { type: "delivery-note", parentId: row.id },
    });
  }

  private allMultipleStorageRows: IStorageModel[] = [];
  private selectedStorageLayerId: string = null;
  private selectedCustomsPackingIds: string[] = [];
  private selectStorageLayerPopoverVisible = false;
  private hqPackingListIdAndSelectedCustomsPackingIdMap: {} = {};
  private poppedCustomsPackingId: string = null;

  private async showSelectStorageLayerPopoverDialog(row: CustomsPacking) {
    this.selectedStorageLayerId = null;
    if (this.allMultipleStorageRows?.length < 1) {
      await getAllMultipleStorageRows().then((data:any) => {
        this.allMultipleStorageRows = data;
        this.selectStorageLayerPopoverVisible = false;
        this.poppedCustomsPackingId = null;
      }).catch(err => {
        console.log(err);
      });
    }
    if (row) {
      this.selectedCustomsPackingIds = [row.id];
      this.poppedCustomsPackingId = row.id;
    } else {
      this.selectStorageLayerPopoverVisible = true;
    }
  }

  private handleMoveInventory() {
    if (!this.selectedStorageLayerId) {
      Message.error({
        message: "请选择仓位",
        duration: 2000,
      });
      return;
    }
    this.listLoading = true;
    moveCustomsPackingStorageLayers({
      storageLayerId: this.selectedStorageLayerId,
      ids: this.selectedCustomsPackingIds,
      deliveryNoteId: this.selectedRow.id,
    })
      .then(() => {
        Message.success({
          message: "操作成功",
          duration: 2000,
        });
        this.closeDialog();
        this.getList();
        this.listLoading = false;
      })
      .catch(() => {
        this.listLoading = false;
        if(this.moveInventoryDialogStatus === 'moveInventory') {
          this.clearSelect();
        }
      });
  }

  private handleCustomsPackingSelection(rows: CustomsPacking[], id: string) {
    console.log('传回来的rows',rows)
    this.hqPackingListIdAndSelectedCustomsPackingIdMap[id] = rows.map(
      (value) => value.id
    );
    const customsPackingIds: string[][] = Object.values(
      this.hqPackingListIdAndSelectedCustomsPackingIdMap
    );
    this.selectedCustomsPackingIds = Object.values(customsPackingIds).reduce(
      (pre, cur) => pre.concat(cur),
      []
    );
  }

  private async handleEditProductNumber(productId: string, totalPcs: number) {
    await updateProductQuantity(productId, { quantity: totalPcs });
    this.queryHqPackingList();
  }

  private onMoveInventoryDialogClosed() {
    this.closeDialog();
    this.poppedCustomsPackingId = null;
    this.selectStorageLayerPopoverVisible = false;
  }

  private async getTotalData(id: string) {
    const data = (await statisticsCustomsPackingData(id)) as Statistics;
    this.statistics = { ...data };
  }
}

class DeliveryNoteStorageLayerInput {
  id: string;
  //预计在仓时间开始
  // estimatedInStorageDateStart: string;
  //预计在仓时间结束
  // estimatedInStorageDateEnd: string;
  //预计下次发货时间
  // estimatedNextDeliveryDate: string;
  remark: string;
  reserved: boolean;
  storageLayerIds: [];
  storageLayerNames: string;

  //进仓单id
  constructor(
    id?: string,
    estimatedInStorageDateStart?: string,
    estimatedInStorageDateEnd?: string,
    estimatedNextDeliveryDate?: string,
    remark?: string
  ) {
    this.id = id;
    // this.estimatedInStorageDateStart = estimatedInStorageDateStart;
    // this.estimatedInStorageDateEnd = estimatedInStorageDateEnd;
    // this.estimatedNextDeliveryDate = estimatedNextDeliveryDate;
    this.remark = remark;
  }
}

class Statistics {
  productVolumeInStockInFact: number;
  productVolumeInStock: number;
  productVolumeNotInStock: number;
  productGrossWeightInStockInFact: number;
  estimatedVolumeNotInStock: number; // 未入库预估体积
}
